export const convertString = (string: string) => {
    const convertedString = string
        .toLowerCase()
        .trim()
        .replace('.', '')
        .replace('!', '')
        .replace(',', '');

    return convertedString;
};
